import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from '../component/Footer';

const Patientreview = () => {
    const reviewsData = [
        {
            name: "John Doe",
            review: "This service is fantastic! I'm truly impressed with the quality and efficiency.",
        },
        {
            name: "Jane Smith",
            review: "Amazing experience! The team was professional and exceeded my expectations.",
        },
        {
            name: "Sam Wilson",
            review: "Highly recommend! Exceptional attention to detail and customer satisfaction.",
        },
        {
            name: "Emily Johnson",
            review: "Loved the service! Definitely coming back again.",
        },
        {
            name: "Michael Brown",
            review: "Superb service quality! Can't wait to recommend it to friends.",
        },
        {
            name: "Sophia Lee",
            review: "The best service experience I've ever had. A++!",
        },
    ];

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    return (

        <>

            <div class="breadcrumb">
                <a href="/">Home</a> / Patient Reviews
            </div>
            <div style={{ width: "80%", margin: "0 auto", padding: "50px 0" }}>
                <h2 style={{ textAlign: "center" }}>Patient Reviews</h2>
                <Slider {...sliderSettings}>
                    {reviewsData.map((review, index) => (
                        <div key={index} style={{ textAlign: "center", padding: "20px" }}>
                            <div
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "50%",
                                    backgroundColor: "#f4f4f4",
                                    color: "#555",
                                    fontWeight: "bold",
                                    fontSize: "18px",
                                    margin: "0 auto 10px",
                                }}
                            >
                                GOOGLE
                            </div>
                            <h3>{review.name}</h3>
                            <p style={{ fontStyle: "italic", color: "#555" }}>{`"${review.review}"`}</p>
                        </div>
                    ))}
                </Slider>
            </div>

            <Footer />

        </>
    );
};

export default Patientreview;
